import { render, staticRenderFns } from "./Curriculum_Report.vue?vue&type=template&id=0d6de327&scoped=true"
import script from "./Curriculum_Report.vue?vue&type=script&lang=js"
export * from "./Curriculum_Report.vue?vue&type=script&lang=js"
import style0 from "./Curriculum_Report.vue?vue&type=style&index=0&id=0d6de327&prod&scoped=true&lang=css"
import style1 from "./Curriculum_Report.vue?vue&type=style&index=1&id=0d6de327&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6de327",
  null
  
)

export default component.exports